import { render, staticRenderFns } from "./StationDetail.vue?vue&type=template&id=fbae01c8&scoped=true"
import script from "./StationDetail.vue?vue&type=script&lang=js"
export * from "./StationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbae01c8",
  null
  
)

export default component.exports